import React, { useState, useEffect, useRef } from 'react';

import { useRecoilState } from 'recoil';
import { partnerMeetStateAtom, partnerMeetConfigAtom, tokenAtom, userAtom, meetTypeAtom, walletAtom } from '../../core/config/atoms';

import { Video, VideoOff, Mic, MicOff, SwitchCamera, Contact } from 'lucide-react';

import { Dialog } from '@headlessui/react';

import ServiceLang from 'services/serviceLang';
import ServiceTransaction from 'services/serviceTransaction';

export default function PanelInitMeet() {

    const [token] = useRecoilState(tokenAtom);
    const [meetType] = useRecoilState(meetTypeAtom);
    const [userData] = useRecoilState(userAtom);
    const [meetState, setMeetState] = useRecoilState(partnerMeetStateAtom);
    const [meetConfig, setMeetConfig] = useRecoilState(partnerMeetConfigAtom);
    const [wallet] = useRecoilState(walletAtom);

    const localStreamRef = useRef();

    const contactRefA = useRef('');
    const contactRefB = useRef('');
    const msgRef = useRef('');
    const langRef = useRef('');

    const [wall, setWall] = useState({});

    const [videoDevices, setVideoDevices] = useState([]);
    const [langOptions, setLangOptions] = useState([]);

    const [selLang, setSelLang] = useState('');
    const [digTitle, setDigTitle] = useState('');
    const [digMsg, setDigMsg] = useState('');

    const [camIndex, setCamIndex] = useState(0);

    const [isVid, setIsVid] = useState(true);
    const [isAudio, setIsAudio] = useState(true);
    const [isError, setIsError] = useState(false);
    const [streamReady, setStreamReady] = useState(false);

    const langService = new ServiceLang();
    const transactionService = new ServiceTransaction();

    const getSubType = () => {
        switch (meetType) {
            case '1':
                return 'on-demand';
            case '2':
                return 'on-partner';
            case '3':
                return 'helpdesk';
        }
    }

    const getTopPriority = (packs) => {
        if (!Array.isArray(packs) || packs.length === 0) {
            return 0;
        }

        return packs.reduce((topPack, currentPack) => {
            return currentPack.priority > topPack.priority ? currentPack : topPack;
        }, packs[0]);
    }

    const createMeet = () => {
        if (!streamReady) {
            setDigTitle('Error Message');
            setDigMsg('Camera not accessible. Please allow camera permissions.!');
            setIsError(true);
            return;
        }

        const msg = msgRef.current.value;
        const name = contactRefA.current.value;
        const number = contactRefB.current.value;
        let ticketConfig = { ...meetConfig };
        switch (meetType) {
            case '1':
            case '2':
                if (userData.user.phone === "1234567811" || userData.user.phone === "1234567810") {
                    ticketConfig.name = `${userData.user.fname}${userData.user.mname === "NA" ? "" : ` ${userData.user.mname}`}${userData.user.lname === "NA" ? "" : ` ${userData.user.lname}`}`;
                    ticketConfig.lang = selLang;
                    ticketConfig.msg = msg === "" ? "NA" : msg;
                    ticketConfig.type = 'customer';
                    ticketConfig.subtype = getSubType();
                    ticketConfig.cid = userData._id;
                    ticketConfig.extra = meetType === "2" ? { 'name': name, 'number': number } : {};
                    ticketConfig.priority = getTopPriority(wall.packBalence)["priority"];
                    setMeetConfig(ticketConfig);
                    setMeetState(1);
                } else {
                    if (wallet.balence > 0) {
                        ticketConfig.name = `${userData.user.fname}${userData.user.mname === "NA" ? "" : ` ${userData.user.mname}`}${userData.user.lname === "NA" ? "" : ` ${userData.user.lname}`}`;
                        ticketConfig.lang = selLang;
                        ticketConfig.msg = msg === "" ? "NA" : msg;
                        ticketConfig.type = 'customer';
                        ticketConfig.subtype = getSubType();
                        ticketConfig.cid = userData._id;
                        ticketConfig.extra = meetType === "2" ? { 'name': name, 'number': number } : {};
                        ticketConfig.priority = getTopPriority(wall.packBalence)["priority"];
                        setMeetConfig(ticketConfig);
                        setMeetState(1);
                    } else {
                        setDigTitle('Error Message');
                        setDigMsg('Low balance please add top up!');
                        setIsError(true);
                    }
                }
                break;
            case '3':
                ticketConfig.name = `${userData.user.fname}${userData.user.mname === "NA" ? "" : ` ${userData.user.mname}`}${userData.user.lname === "NA" ? "" : ` ${userData.user.lname}`}`;
                ticketConfig.lang = selLang;
                ticketConfig.msg = msg === "" ? "NA" : msg;
                ticketConfig.type = 'customer';
                ticketConfig.subtype = getSubType();
                ticketConfig.cid = userData._id;
                ticketConfig.extra = meetType === "2" ? { 'name': name, 'number': number } : {};
                ticketConfig.priority = 0;
                setMeetConfig(ticketConfig);
                setMeetState(1);
                break;
        }
    }

    const toggleVideo = () => {
        const videoTracks = localStreamRef.current.srcObject.getVideoTracks();
        if (videoTracks.length > 0) {
            videoTracks[camIndex].enabled = !isVid;
            setIsVid(!isVid);
        }
    }

    const toggleAudio = () => {
        const audioTracks = localStreamRef.current.srcObject.getAudioTracks();
        if (audioTracks.length > 0) {
            audioTracks[0].enabled = !isAudio;
            setIsAudio(!isAudio);
        }
    }

    const toggleCamera = async () => {
        try {
            let nextCamIndex = 0;
            if (camIndex === 0) {
                nextCamIndex = (camIndex + 1) % videoDevices.length;
            }
            setCamIndex(nextCamIndex);

            const constraints = {
                video: {
                    deviceId: { exact: videoDevices[nextCamIndex].deviceId },
                },
            };

            const newStream = await navigator.mediaDevices.getUserMedia(constraints);
            const oldStream = localStreamRef.current.srcObject;

            const oldVideoTrack = oldStream.getVideoTracks()[0];
            const newVideoTrack = newStream.getVideoTracks()[0];

            oldStream.removeTrack(oldVideoTrack);
            oldVideoTrack.stop();

            oldStream.addTrack(newVideoTrack);
            localStreamRef.current.srcObject = oldStream;
        } catch (err) {
            console.error("Error switching camera:", err);
        }
    }

    const initData = async () => {
        var resW = await transactionService.getWalletById({ 'wKey': wallet.walletKey }, token);
        if (resW.data !== null) {
            setWall(resW['data']);
        }

        var langRes = await langService.getLangOptions({}, token);
        setLangOptions(langRes.data);
        setSelLang(userData.langs[0]);
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
            setStreamReady(true);
            setTimeout(() => {
                if (localStreamRef.current) {
                    localStreamRef.current.srcObject = stream;
                }
            }, 300);
        } catch (err) {
            console.error("Camera access denied or error:", err);
            setStreamReady(false);
        }
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoInputs = devices.filter(device => device.kind === "videoinput");
        setVideoDevices(videoInputs);
    }

    useEffect(() => {
        initData();
        return () => {
            console.log("here");
        };
    }, [meetState]);

    return (
        <>
            <Dialog open={isError} onClose={() => { setIsError(false) }} className='overflow-y-auto overflow-x-hidden z-[100] w-full min-h-screen fixed top-0 left-0 bg-black bg-opacity-70 flex items-center justify-center'>
                <div className="w-[90%] md:w-[40%] bg-white shadow-lg rounded-md p-4">
                    <div className='flex items-center justify-between'>
                        <h3 className="text-lg font-semibold text-gray-900">
                            {digTitle} &nbsp;
                        </h3>
                    </div>
                    <hr className='mt-1' />
                    <h3 className="text-base text-gray-900 py-2">
                        {digMsg} &nbsp;
                    </h3>
                    <div className="px-2 py-3 text-right" onClick={() => {
                        setDigMsg('');
                        setDigTitle('');
                        setIsError(false);
                    }}>
                        <button type="button" className="p-1 text-sm font-medium text-prime">
                            OK
                        </button>
                    </div>
                </div>
            </Dialog>
            <div className='w-full h-full grid grid-cols-12 gap-4'>
                <div className='col-span-12 xl:col-span-8 h-full rounded-2xl flex items-center justify-center'>
                    <div className='w-full pt-[120%] xl:pt-[56.25%] relative'>
                        <div className='w-full h-full'>
                            <video ref={localStreamRef} autoPlay playsInline muted className={`border-2 border-prime rounded-2xl object-fill absolute inset-0 w-full h-full transform scale-x-[-1]`} />
                            {
                                !isVid && <div className="absolute left-[50%] translate-x-[-50%] inset-0 h-full w-full flex items-center justify-center bg-black rounded-2xl overflow-hidden">
                                    {
                                        userData.profileMedia !== undefined && <div className='w-32 h-32 rounded-full flex items-center justify-center overflow-hidden border-4 border-white shadow shadow-white'>
                                            <img src={Object.keys(userData.profileMedia).length === 0 ? "https://storage.ishcallsign.com/storage/ish-assets/default.jpeg" : userData.profileMedia.fileurl} alt='User Image' className='w-32 h-32 rounded-full object-cover' />
                                        </div>
                                    }
                                    {
                                        userData.profileMedia === undefined && <div className='w-32 h-32 rounded-full flex items-center justify-center overflow-hidden border-4 border-white shadow shadow-white'>
                                            <img src="https://storage.ishcallsign.com/storage/ish-assets/default.jpeg" alt="Profile" className="w-32 h-32 rounded-full object-cover" />
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        <div className='w-[40%] h-[60px] flex items-center justify-center absolute bottom-0 left-[30%]'>
                            <div className={`w-10 h-10 cursor-pointer rounded-2xl mx-2 text-white flex items-center justify-center bg-gray-800`} onClick={() => {
                                toggleCamera();
                            }}>
                                <SwitchCamera size={18} />
                            </div>
                            <div className={`w-10 h-10 cursor-pointer rounded-2xl mx-2 text-white flex items-center justify-center ${isVid ? 'bg-gray-800' : 'bg-red-600'}`} onClick={() => {
                                toggleVideo();
                            }}>
                                {isVid && <Video size={18} />}
                                {!isVid && <VideoOff size={18} />}
                            </div>
                            <div className={`w-10 h-10 cursor-pointer rounded-2xl mx-2 text-white flex items-center justify-center ${isAudio ? 'bg-gray-800' : 'bg-red-600'}`} onClick={() => {
                                toggleAudio();
                            }}>
                                {isAudio && <Mic size={18} />}
                                {!isAudio && <MicOff size={18} />}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-span-12 xl:col-span-4 flex items-center justify-center'>
                    <div className='w-full bg-white shadow-inner rounded-2xl flex flex-col p-6 border'>
                        <form className='w-full'>
                            <div className="col-span-6 mt-4">
                                <label className="text-sm font-medium text-gray-700 font-mono flex">Language Preference<sup className="text-red-600">*</sup></label>
                                <select id="lang" ref={langRef} className="mt-2 p-2 block w-full bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" onChange={(e) => {
                                    setSelLang(langRef.current.value);
                                }}>
                                    {
                                        langOptions.length !== 0 && langOptions.map((item) => {
                                            return <option value={item.value} selected={item.value === selLang}>{item.label}</option>
                                        })
                                    }
                                </select>
                            </div>
                            {
                                meetType === "2" && <div className="col-span-6 mt-2">
                                    <label className="text-xs font-medium text-gray-700 font-mono flex">Contact Name<span className="block text-[10px] text-gray-400 font-mono">(Optional)</span></label>
                                    <div className="relative mt-2">
                                        <input type="text" id="contact" ref={contactRefA} autoComplete="off" className="p-2 pr-10 block w-full bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="Contact name" />
                                        <Contact className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
                                    </div>
                                </div>
                            }
                            {
                                meetType === "2" && <div className="col-span-6 mt-2">
                                    <label className="text-xs font-medium text-gray-700 font-mono flex">Contact Phone Number<span className="block text-[10px] text-gray-400 font-mono">(Optional)</span></label>
                                    <div className="relative mt-2">
                                        <input type="number" id="contact" ref={contactRefB} autoComplete="off" className="p-2 pr-10 block w-full bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="Contact number" />
                                        <Contact className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
                                    </div>
                                </div>
                            }
                            <div className="col-span-6 mt-4">
                                <label className="text-sm font-medium text-gray-700 font-mono flex">Your Message <span className="block text-[10px] text-gray-400 font-mono">(Optional)</span></label>
                                <textarea type="message" id="message" ref={msgRef} autoComplete="off" className="mt-2 p-2 block w-full bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="Message"></textarea>
                            </div>
                            <div className='flex justify-center mt-4'>
                                <button type="button" className="inline-flex justify-center w-[240px] py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-prime hover:bg-blue-700" onClick={() => { createMeet(); }}>
                                    JOIN NOW
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
